var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tag-cloud",class:{ limited: _vm.limited }},_vm._l((_vm.tags),function(tag,index){return _c('tag-badge',{key:index,staticClass:"mr-1",attrs:{"resource":tag,"data-cy":_vm.dataCy,"variant":_vm.variant,"size":_vm.size,"include-hashtag":_vm.includeHashtag}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }